import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vadiun/react-components';
import { useVerifyAction } from '@vadiun/react-hooks-legacy';
import React from 'react';
import { Table } from 'shared/components';
import { ClientBusinessPartialModel } from '../models/ClientBusiness';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';

interface Props {
  clients: ClientBusinessPartialModel[];
  delete: (cliente: ClientBusinessPartialModel) => void;
  restore: (cliente: ClientBusinessPartialModel) => void;
  onClientModifyButton: (id: number) => React.ReactNode;
  handlePageChange: (currentPage: number) => void;
}

const ClientBusinessTable = (props: Props) => {
  const verifyAction = useVerifyAction();
  const columns = [
    {
      name: 'code',
      label: 'Código',
      options: {
        filter: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="flex justify-center">
              <div className="flex bg-blue-50 text-blue-900 b-1 border-b-2 border-t-2 border-blue-300 p-2 justify-center">
                {value}
              </div>
            </div>
          );
        }
      }
    },
    {
      name: 'businessName',
      label: 'Razon Social',
      options: {
        filter: false
      }
    },
    {
      name: 'fantasyName',
      label: 'Nombre fantasía',
      options: {
        filter: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="flex ">
              <span style={{backgroundColor: '#000224'}} className="flex  border-l-4 border-r-0 border-blue-500 text-blue-50 whitespace-nowrap py-1 px-4 rounded-md">{value}</span>
            </div>
          );
        }
      }
    },
    {
      name: 'cuit',
      label: 'Cuit',
      options: {
        filter: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="flex text-blue-900 gap-4 bg-blueGray-50">
              <span className="text-blue-800 whitespace-nowrap">{value}</span>
            </div>
          );
        }
      }
    },
    {
      name: 'isDeleted',
      label: 'Borrado',
      options: {
        display: false,
        filterOptions: {
          names: ['Si', 'No']
        },
        filterList: ['No'],
        customFilterListOptions: { render: (v) => `Borrado: ${v}` }
      }
    },
    {
      label: 'Acciones',
      name: 'id',
      options: {
        filter: false,

        customBodyRenderLite: (index: number) =>
          props.clients[index].isDeleted ? (
            <Button onClick={() => props.restore(props.clients[index])}>
              Restaurar
            </Button>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start'
              }}
            >
              {props.onClientModifyButton(props.clients[index].id)}
              <Button
                onClick={() =>
                  verifyAction({
                    title: '¡Estás por eliminar un cliente!',
                    body: 'Esta acción va a eliminar al cliente. ¿Estás seguro?',
                    onAccept: () => props.delete(props.clients[index])
                  })
                }
                shape="circle"
                color="red"
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
          )
      }
    }
  ];

  const data = props.clients.map((x) => ({
    ...x,
    isDeleted: x.isDeleted ? 'Si' : 'No'
  }));

  return (
    <div className="w-full">
      <Table
        options={{
          elevation: 0,
          selectableRows: 'none',
          print: false,
          onDownload: () => {
            alert('IMPRIMIR');
            return false;
          },
          onChangePage: props.handlePageChange
        }}
        title={
          <div className="flex gap-4 justify-start items-center">
            <div className="flex gap-1">
              <FontAwesomeIcon icon={faUserTie} size="1x" />
            </div>
            <div>Empresas</div>
          </div>
        }
        data={data}
        columns={columns}
      />
    </div>
  );
};
export default ClientBusinessTable;
